<template>
  <div ref="container">
    <a-drawer
      title="生码列表"
      width="87vw"
      :visible="visible"
      :maskClosable="false"
      :mask="false"
      :confirmLoading="confirmLoading"
      :wrapClassName="wrapClassNameInfo()"
      @ok="handleOk"
      @close="handleCancel"
      cancelText="取消"
      okText="保存"
      :destroyOnClose="true">
          <a-card>
            <div>
              <a-table
                ref="table"
                size="middle"
                bordered
                rowKey="uuid"
                :columns="columns"
                :dataSource="dataSource"
                :pagination="ipagination"
                @change="handleTableChange">
              </a-table>
            </div>
          </a-card>
<!--        </a-col>-->
<!--      </a-row>-->
      <template slot="footer">
        <a-button key="back" v-if="isReadOnly" @click="handleCancel">
          取消
        </a-button>
      </template>
    </a-drawer>
  </div>
</template>
<script>
  import pick from 'lodash.pick'
  import { makeCodeRecordListModalList, generatedDetailById, queryEnableDictItemsByCode } from '@/api/identifierCode/identifierCode'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {autoJumpNextInput} from "@/utils/util"
  import {mixinDevice} from '@/utils/mixin'
  import JSelectMultiple from '@/components/jeecg/JSelectMultiple'
  import { getAction } from '@api/manage'
  export default {
    name: "MakeCodeRecordListModal",
    mixins: [mixinDevice, JeecgListMixin],
    components: {
      JSelectMultiple
    },
    data () {
      return {
        // 查询区域布局
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 18,
          offset: 1
        },

        // 查询条件
        queryParam: {
          ruleId: this.ruleId
        },
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: '',
            key:'rowIndex',
            width: '5%',
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {title: '编码333 ', dataIndex: [], width: '60vw', align:"center"},
        ],
        url: {
          list: "/codeRules/fzIdcodeBatch/list",
          delete: "/codeRules/fzIdcodeBatch/delete",
          deleteBatch: "/codeRules/fzIdcodeBatch/deleteBatch"
        },

        title:"操作",
        visible: false,
        model: {},
        enabledSwitch: true, //是否启用
        isReadOnly: false,
        jselectMultiple: {
          options: [
            { text: '编辑', value: '1' },
            { text: '审核', value: '2' },
            { text: '反审核', value: '7' },
            { text: '导出', value: '3' },
            { text: '启用禁用', value: '4' },
            { text: '打印', value: '5' },
            { text: '作废', value: '6' }
          ],
          value: ''
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{

        },
        uuid: null,
        ruleId: null,
        qveData: null,
        qveData2: null,
        ipagination: {
          current: 1,
          pageSize: 5,
          pageSizeOptions: ['5', '10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
      }
    },
    created () {
    },
    methods: {
      add (qve) {

      },
      edit (record) {

      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {

      },
      handleCancel () {

        this.close()
      },
      async getList(uuid, ruleId) {
        this.uuid = uuid
        this.ruleId = ruleId
        let pageNo = this.ipagination.current
        let pageSize = this.ipagination.pageSize

        // getAction('codeRules/fzIdcode/generating/list',{
        //   column:createTime,
        //   order:desc,
        //   pageNo:1&pageSize=10&ruleId=92&uuid=153&_t=1724743567068
        // })

        this.visible = true;
      },

    }
  }
</script>